module.exports = __webpack_public_path__ + "static/media/HeroImage.ab567173.png";